module.exports = __webpack_public_path__ + "static/media/features_inventario.e9d1c439.jpg";